<template>
    <div class="app">
        <Base v-if="show" />
        <Alert v-if="alert.show" :msg="alert.msg" v-on:close="closeAlert" :type="alert.type"></Alert>
        <Modal v-if="modal.show" class="fadeIn animated">
            <Rule v-if="modal.type == 'rule'" v-on:close="close"></Rule>
            <Card v-if="modal.type == 'card'" :card_id="modal.card_id" :share="modal.share" v-on:close="close"></Card>
            <Code v-if="modal.type == 'code'" :code="modal.code" v-on:close="close"></Code>
            <Record v-if="modal.type == 'record'" :card_id_list="modal.card_id_list" v-on:close="close"></Record>
        </Modal>
        <Loading v-if="loading"></Loading>
        <Guide v-if="showGuide"></Guide>
        <Orientation v-if="isLandscape"></Orientation>
        <!-- <div class="account" :class="[moreTop ? 'more_top' : '']" v-if="show">
          <div class="name">
            您好!
            <span :class="[moreTop ? 'nickname' : '']">{{nickname}}</span>
          </div>
          <a class="text_btn" @click="changeAccount">更换账号</a>
        </div> -->
    </div>
</template>
<style rel="stylesheet/stylus" lang="stylus">
    .app
        width 100%
        height 100%
    ::-webkit-scrollbar
        width: 6px;
        height: 6px;
        /* background-color:#fff; */
        display: none;

    ::-webkit-scrollbar:hover
        background-color: #eee;

    ::-webkit-scrollbar-thumb
        min-height: 5px;
        min-width: 5px;
        -webkit-border-radius: 20px;
        border: 1px solid #AAA;
        background-color: #AAA;

    ::-webkit-scrollbar-thumb:hover
        min-height: 5px;
        min-width: 5px;
        -webkit-border-radius: 20px;
        border: 1px solid #444;
        background-color: #444;

    ::-webkit-scrollbar-thumb:active
        -webkit-border-radius: 20px;
        border: 1px solid #444;
        background-color: #444;
</style>
<script>
    import {mapState} from 'vuex';
    import Vue from 'vue';
    import Alert from './components/Alert/alert.vue';
    import Base from './views/base/base.vue';
    import Loading from './components/loading.vue';
    import Modal from './components/Modal/modal.vue';
    import Rule from './components/Rule/rule.vue';
    import Card from './components/Card/card.vue';
    import Code from './components/Code/code.vue';
    import Record from './components/Record/record.vue';
    import Guide from './components/Guide/guide.vue';
    import Orientation from './components/Orientation/orientation.vue';
    import store from './store/index';
    import * as types from './store/mutation-type';
    import clipboard from 'clipboard';
    // import { isWeiXin } from '~/tools/utils';
    import 'animate.css/animate.min.css';
    import '@babel/polyfill';

    Vue.prototype.clipboard = clipboard;

    export default{
        computed: {
            ...mapState({
                modal: state => state.modal,
                loading: state => state.loading,
                showGuide: state => state.showGuide,
                alert: state => state.alert
            })
        },
        data() {
          return {
            show: false,
            isLandscape: false
          }
        },
        mounted() {
          store.commit(types.SHOW_LOADING, true);
          document.body.addEventListener('focusout', function () {
            window.scrollTo(0, document.documentElement.clientHeight);
          });
          if(process.env.VUE_APP_ENV !== 'development') {
            requirejs([ 'weixin/set'], function (setShare) {
              let imgUrl = require('./images/share.png');
              window.shareconfig = {
                  appid: "wx0fcf7f47419c8171",
                  title: '中秋祈愿领节日时装头饰', // 分享标题，如果不设置会获取页面的
                  desc: '《征途2手游》中秋团圆聚兄弟，快来看看你的专属福卡吧~', // 分享描述
                  link: process.env.VUE_APP_ENV == 'pre' ? 'https://zt2m.web.ztgame.com/act/moon2019/' : 'https://zt2m.ztgame.com/act/moon2019/', // 分享链接，如果和当前访问的域不完全一致会导致分享自定义失败
                  imgUrl: location.href.replace('https', 'http').split('act')[0] + imgUrl, // 分享图标
                  type: 'link', // 分享类型,music、video或link，不填默认为link ,只在微信下起作用
                  dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空,只在微信下起作用
                  success: function () {
                      // 用户确认分享后执行的回调函数,只在微信下起作用
                      window.shareconfig.link = process.env.VUE_APP_ENV == 'pre' ? 'https://zt2m.web.ztgame.com/act/moon2019/' : 'https://zt2m.ztgame.com/act/moon2019/';
                      setShare(window.shareconfig);
                  },
                  cancel: function () {
                      // 用户取消分享后执行的回调函数,只在微信下起作用
                  }
              }
              setShare(window.shareconfig);
              window.setShare = setShare;
              //如果需要重新设置分享信息只需要重新执行 setShare()方法
            });
          }
          this.show = true;
          this.checkOrientation();
          this.onOrientationChange();
        },
        components: {
            Alert,
            Loading,
            Guide,
            Rule,
            Modal,
            Card,
            Code,
            Record,
            Base,
            Orientation
        },
        methods: {
          closeAlert() {
              store.commit(types.HIDE_ALERT);
          },
          close() {
              store.commit(types.HIDE_MODAL);
          },
          onOrientationChange() {
              let resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
              let _this = this;
              window.addEventListener(resizeEvt, () => {
                  setTimeout(()=>{
                      _this.checkOrientation();
                  }, 300);
              }, false);
          },
          checkOrientation() {
            let ww = window.innerWidth,
                wh = window.innerHeight;
            if (ww > wh) {
                this.isLandscape = true;
            } else {
                this.isLandscape = false;
            }
          }
        }
    }
</script>
